module.exports = __webpack_public_path__ + "img/logo.7d544e92.svg";